<div class="tab-pane" role="tabpanel" id="normas_urbanisticas">
    <fieldset id="agregar_normas" class="">
        <div class="step_section">
            <form [formGroup]="form">
                <h3 class="form-signin-heading"><strong>Normas Urbanisticas Aplicadas</strong></h3>
                <hr />
                <div class="form-horizontal">
                    <div class="form-group col-md-12 titulos" >
                        <strong>Coeficiente de Constructibilidad:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="constr_perm" name="constr_perm" formControlName="constr_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="constr_proy" name="constr_proy" formControlName="constr_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  > 
                        <strong >Coeficiente de Ocupacion Pisos Superiores:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="ocup_perm" name="ocup_perm" formControlName="ocup_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="ocup_proy" name="ocup_proy" formControlName="ocup_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Altura Maxima en Metros o Pisos:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="alt_perm" name="alt_perm" formControlName="alt_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="alt_proy" name="alt_proy" formControlName="alt_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Rasante:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="rasant_perm" name="rasant_perm" formControlName="rasant_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="rasant_proy" name="rasant_proy" formControlName="rasant_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="form-group col-md-12 titulos"  >
                        <strong>Distanciamiento:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="dist_perm" name="dist_perm" formControlName="dist_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="dist_proy" name="dist_proy" formControlName="dist_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong >Coeficiente de Ocupacion de Suelo:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="suelo_perm" name="suelo_perm" formControlName="suelo_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="suelo_proy" name="suelo_proy" formControlName="suelo_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Densidad:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="densid_perm" name="densid_perm" formControlName="densid_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="densid_proy" name="densid_proy" formControlName="densid_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Adosamiento:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="adosam_perm" name="adosam_perm" formControlName="adosam_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="adosam_proy" name="adosam_proy" formControlName="adosam_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Antejardin:</strong>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>

                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Permitido" id="antej_perm" name="antej_perm" formControlName="antej_perm" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyectado</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="antej_proy" name="antej_proy" formControlName="antej_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group col-md-12 titulos"  >
                        <strong>Estacionamiento:</strong>
                    </div>
                    <div class="form-group col-md-12">

                        <div class="col-md-3">
                            <label for="dest" class="labels">Permitido</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="permitido" id="est_req" name="est_req" formControlName="est_req" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"><label for="dest" class="labels">Proyecto</label></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="proyectado" id="est_proy" name="est_proy" formControlName="est_proy" (change)="add_normas_urbanisticas()" >
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>
</div>